import { useHandleNeedsMfa } from 'utils/customHooks/useHandleNeedsMfa';
import { useCheckOrgAccess } from 'utils/customHooks/useCheckOrgAccess';

interface OpAppPreChecksProps {
  basename: string;
}
export const OpAppPreChecks = ({ basename }: OpAppPreChecksProps) => {
  useCheckOrgAccess(basename);
  useHandleNeedsMfa();
  return null;
};
